export default __webpack_public_path__ + "static/char-v-09-jam-ce08563a0383ee30c0faa3db455c9843.mp4";